import { useEffect, useState } from "react";

import BreadCrumbForm from "./common-components/BreadCrumbForm";
import FormHeading from "./common-components/FormHeading";

import {
  assessmentSections,
  attendanceOptions,
  probationFormFields,
  probationOutcomeOptions,
} from "./form-data/probationForm-data";
import { styles } from "./styles/probation-form";
// import TextareaInput from "./common-components/TextAreaInput";
import InlineTextInput from "./common-components/InlineTextInput";
import { DatePicker } from "antd";
import InlineDateField from "./common-components/InlineDateField";
import {
  getFirstError,
  validateProbationForm,
  validateRatings,
} from "./validation/form-validations/probation-validation";
import Swal from "sweetalert2";
import useApi from "../../core/customhook/useApi";
import dayjs from "dayjs";
import { useEmployeeHook } from "./hook/useEmployeeHook";
import SearchableSelect from "../../core/common/searchable-select/SearchableSelect";
import { useNavigate, useParams } from "react-router";
import Loading from "../../core/common/custom-loading/Loading";
import { all_routes } from "../router/all_routes";
import {
  // GET_EMP_REQUIRED_DATA,
  GET_EMP_REQUIRED_DATA2,
  GET_PROBATION_BY_EMPID,
} from "../../environment";

import { buildFormData } from "../../core/common-methods/buildFormData";
import { toast } from "react-toastify";
import ViewSignature from "../../core/common/ViewSignature";
import ESignaturePad from "../../core/common/ESignaturePad";

interface FieldProps {
  label: string;
  name: string;
  type?: string;
  value?: string;
  errors?: Record<string, string>;
}
// interface CheckCellProps {
//   rowName: any;
//   opt: any;
// }

export interface RatingProps {
  abilityToLearn: string;
  industry: string;
  initiative: string;
  cooperativeness: string;
  accuracy: string;
  abilityToSupervise: string;
  knowledgeOfWork: string;
}

export type ProbationFormState = {
  employeeName: string;
  employeeCode: string;
  dateOfAppointment: string;
  designation: string;
  function: string;
  periodOfProbation: string;
  location: string;
  dueForConfirmation: string;
  attendance: string;
  ratings: RatingProps;
  finalDecision: string;
  terminationDate: string;
  confirmationRemarks: string;
  extensionReason: string;
  terminationReason: string;
  managerName: string;
  managerSignature: File | null;
  dateManagerSign?: string;
  hrName: string;
  hrSignature: string;
  dateHrSign?: string;

  signature_url_manager: string
};

const initialFormData: ProbationFormState = {
  employeeName: "",
  employeeCode: "",
  dateOfAppointment: "",
  designation: "",
  function: "",
  periodOfProbation: "",
  location: "",
  dueForConfirmation: "",

  attendance: "",
  ratings: {
    abilityToLearn: "",
    industry: "",
    initiative: "",
    cooperativeness: "",
    accuracy: "",
    abilityToSupervise: "",
    knowledgeOfWork: "",
  },
  finalDecision: "",
  extensionReason: "",
  terminationReason: "",
  terminationDate: "",
  confirmationRemarks: "",

  managerName: "",
  managerSignature: null,
  dateManagerSign: "",

  hrName: "Harneet Seth",
  hrSignature: "",
  dateHrSign: "",

  signature_url_manager: "",
};

const ProbationAssessmentForm = () => {
  const { id, assessment_id, emp_id } = useParams();
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState<ProbationFormState>(initialFormData);
  const { loading_newJoinerById } = useEmployeeHook();
  const navigate = useNavigate();

  const [isAlreadySaved, setIsAlreadySaved] = useState(false)

  // ---- api ----
  const {
    callApi: probationFormApi,
    loading: submitLoading,
    error,
  } = useApi("/api/probation/save", {
    method: "POST",
    autoCall: false,
  });
  const { callApi: fetchProbationDataAPI, loading: fetchLoading } = useApi("", {
    method: "GET",
    autoCall: false,
  });
  const { callApi: fetchEmployeePreData, loading: getEmpLoading } = useApi(
    GET_EMP_REQUIRED_DATA2,
    {
      method: "POST",
      // method: "GET",
      autoCall: false,
    },
  );
  // --- / api ---

  const handleError = (name: keyof ProbationFormState) =>
    setErrors((prev: any) => {
      const { [name]: _, ...rest } = prev;
      return rest;
    });

  const handleDateChange = (name: string, value: string) => {
    const [day, month, year] = value?.split("-");
    const formatted = `${year}-${month}-${day}`;
    setFormData((prev) => ({ ...prev, [name]: formatted }));
    handleError(name as keyof ProbationFormState);
  };

  const handleFieldDataChange = (name: string, value: string) => {
    setFormData((prev: ProbationFormState) => ({
      ...prev,
      [name]: prev[name as keyof ProbationFormState] == value ? "" : value,
    }));
    handleError(name as keyof ProbationFormState);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target;
    setFormData((prev: ProbationFormState) => ({
      ...prev,
      [name]: value,
    }));
    handleError(name as keyof ProbationFormState);
  };

  const handleRatingChange = (secName: string, opt: string) => {
    const updatedRatings = {
      ...formData.ratings,
      [secName]:
        formData.ratings[secName as keyof RatingProps] === opt ? "" : opt,
    };

    setFormData((prev: ProbationFormState) => ({
      ...prev,
      ratings: updatedRatings,
    }));

    setErrors((prev: any) => {
      const { [secName]: _, ...rest } = prev;
      return rest;
    });
  };

  // ---- handle submit form Data ----
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // console.log("data:", formData);

    if (!id || !assessment_id) return;

    const validationErrors = validateProbationForm(formData);
    const validationErrors_ratings = validateRatings(formData?.ratings);

    if (
      Object.keys(validationErrors).length > 0 ||
      Object.keys(validationErrors_ratings).length > 0
    ) {
      setErrors((prev: any) => ({
        ...prev,
        ...validationErrors,
        ...validationErrors_ratings,
      }));

      const firstError = getFirstError(
        validationErrors,
        validationErrors_ratings,
      );
      Swal.fire({
        icon: "error",
        title: "Validation Error!",
        text: firstError ?? "Please fill all required fields",
        confirmButtonText: "OK",
        confirmButtonColor: "#fd7e14",
      });
      return;
    }

    const payload = {
      emp_id: id,
      assessment_id: assessment_id,
      employee_name: formData?.employeeName,
      employee_code: formData?.employeeCode,
      date_of_appointment: formData?.dateOfAppointment ?? "",
      designation: formData?.designation ?? "",
      function: formData?.function ?? "",
      period_of_probation: formData?.periodOfProbation ?? "",
      location: formData?.location ?? "",
      due_for_confirmation: formData?.dueForConfirmation ?? "",

      attendance_rating: formData?.attendance ?? "",
      ability_to_learn: formData?.ratings?.abilityToLearn ?? "",
      industry: formData?.ratings?.industry ?? "",
      initiative: formData?.ratings?.initiative ?? "",
      cooperativeness: formData?.ratings?.cooperativeness ?? "",
      accuracy: formData?.ratings?.accuracy ?? "",
      ability_to_supervise: formData?.ratings?.abilityToSupervise ?? "",
      knowledge_of_work: formData?.ratings?.knowledgeOfWork ?? "",

      final_decision: formData?.finalDecision ?? "",
      confirmation_remarks: formData?.confirmationRemarks ?? "",
      extension_reason: formData?.extensionReason ?? "",
      termination_reason: formData?.terminationReason ?? "",
      termination_effective_from: formData?.terminationDate ?? "",

      manager_hod_name: formData?.managerName ?? "",
      manager_hod_date: formData?.dateManagerSign ?? "",
      signature: formData?.managerSignature ?? "",

      human_resources_name: formData?.hrName ?? "",
      human_resources_date: formData?.dateHrSign ?? "",
    };

    const formDataToSend = new FormData();
    buildFormData(formDataToSend, payload);

    try {
      const response = await probationFormApi(formDataToSend);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Submitted!",
          text: "Form submitted successfully",
          confirmButtonText: "OK",
          confirmButtonColor: "#fd7e14",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(all_routes.managerEnabledProbationAssessment, {
              replace: true,
            });
          }
        });
        setFormData(initialFormData);
      }
    } catch (error: any) {
      console.log("error message", error.response);
      const errorMsg = error.response?.data?.message ?? null;
      toast.error(errorMsg ?? "Failed to submit form!")
      // Swal.fire({
      //   icon: "error",
      //   title: "Failed!",
      //   text: errorMsg ?? "Failed to submit form data.",
      //   confirmButtonText: "OK",
      //   confirmButtonColor: "#fd7e14",
      // });
    }
  };

  useEffect(() => {
    if (!id) return;
    const fetchEmpData = async () => {
      try {
        const res = await fetchEmployeePreData({
          emp_id: id,
        });
        if (res?.success) {
          const resData = res?.data || {};
          setFormData((prev) => ({
            ...prev,
            employeeName: resData?.full_name ?? "",
            employeeCode: resData?.employee_id ?? "",
            department: resData?.department ?? "",
            designation: resData?.designation ?? "",
            dateManagerSign: dayjs().format("YYYY-MM-DD"),
            dateHrSign: dayjs().format("YYYY-MM-DD")
          }));
        }
      } catch (error) {
        console.error("failed to fetch:", error);
      }
    };
    fetchEmpData();
  }, [id, assessment_id]);
  // ---- end handle submit form Data ----

  // --- fetch details only if we have 'emp_id' ---
  const fetchData = async () => {
    try {
      const response = await fetchProbationDataAPI(
        undefined,
        `${GET_PROBATION_BY_EMPID}/${emp_id}`,
      );
      if (response?.success) {
        const resData = response?.data[0] || null;

        if (!resData) {
          return;
        };
        setIsAlreadySaved(true);
        setFormData((prev) => ({
          ...prev,
          employeeName: resData?.employee_name ?? "",
          employeeCode: resData?.employee_code ?? "",
          dateOfAppointment: resData?.date_of_appointment ?? "",
          designation: resData?.designation ?? "",
          function: resData?.functions ?? "",
          periodOfProbation: resData?.period_of_probation ?? "",
          location: resData?.location ?? "",
          dueForConfirmation: resData?.due_for_confirmation ?? "",

          attendance: resData?.attendance_rating ?? "",
          ratings: {
            abilityToLearn: resData?.ability_to_learn ?? "",
            industry: resData?.industry ?? "",
            initiative: resData?.initiative ?? "",
            cooperativeness: resData?.cooperativeness ?? "",
            accuracy: resData?.accuracy ?? "",
            abilityToSupervise: resData?.ability_to_supervise ?? "",
            knowledgeOfWork: resData?.knowledge_of_work ?? "",
          },
          finalDecision: resData?.final_decision ?? "",
          extensionReason: resData?.extension_reason ?? "",
          terminationReason: resData?.termination_effective_from ?? "",
          terminationDate: resData?.termination_effective_from ?? "",
          confirmationRemarks: resData?.confirmation_remarks ?? "",
          managerName: resData?.manager_hod_name ?? "",
          dateManagerSign: resData?.manager_hod_date ?? "",
          hrName: resData?.human_resources_name ?? "",
          dateHrSign: resData?.human_resources_date ?? "",
          hrSignature: "",

          signature_url_manager: resData?.signature ?? ""
        }));
      }
    } catch (error) {
      console.error("failed to fetch:", error);
    }
  };

  useEffect(() => {
    if (!emp_id) return;
    fetchData();
  }, [emp_id]);

  // handleSignatureChange
  const handleSignatureChange = (
    field: keyof ProbationFormState,
    file: File | null,
  ) => {
    setFormData((prev) => ({ ...prev, [field]: file }));
    handleError(field);
  };

  // --- fetch from local storage ---
  // useEffect(() => {
  //   const storedManagerName = localStorage.getItem("employee_name");
  //   if (storedManagerName) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       managerName: storedManagerName,
  //       managerSignature: storedManagerName,
  //     }));
  //   }
  // }, []);

  // console.log("emp_id:", emp_id);

  const isFieldsNonEditable: boolean =
    emp_id && String(emp_id)?.length > 0 ? true : false;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <BreadCrumbForm
            title={"Probation Assessment Form"}
            linkTitle="Probation Assessment Form"
            hasBackButton={true}
            backLink={`${all_routes.managerEnabledProbationAssessment}`}
          />

          {/* Form Content */}
          <div className="card shadow-sm mt-4 form-card-container ">
            <div className="card-body p-4 pt-5">
              {/* Title */}
              <FormHeading title="Probation Assessment Form" />
              {/* {loading_employeeById || submitLoading ? ( */}
              {loading_newJoinerById || getEmpLoading || fetchLoading ? (
                <Loading />
              ) : (
                <form onSubmit={handleSubmit}>
                  {/* Employee Details */}
                  <div style={styles.section}>
                    <div className="d-md-grid " style={styles.fieldGrid}>
                      <InlineTextInput
                        label={"Employee Name:"}
                        name={"employeeName"}
                        value={formData.employeeName}
                        onChange={handleChange}
                        isFlexGrow={true}
                        isReadOnly={true}
                      />

                      {probationFormFields?.map((field) =>
                        field.type === "date" ? (
                          <InlineDateField
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            value={
                              String(
                                formData[
                                field?.name as keyof ProbationFormState
                                ],
                              ) ?? ""
                            }
                            disabled={field.disabled || isFieldsNonEditable}
                            isDisabledDate={false}
                            onChange={handleDateChange}
                            errors={errors}
                          />
                        ) : (
                          <InlineTextInput
                            label={field.label}
                            name={field.name}
                            value={String(
                              formData[field.name as keyof ProbationFormState],
                            )}
                            classStyle="text-capitalize"
                            onChange={handleChange}
                            errors={errors}
                            isFlexGrow={true}
                            isReadOnly={field.disabled || isFieldsNonEditable}
                          />
                        ),
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      // background: "#ccc",
                      paddingBottom: "0.6rem",
                      borderTop: "1px solid #ccc",
                    }}
                  />

                  {/* Attendance */}
                  <div className="mb-0 pb-1" style={styles.sectionBorder}>
                    <p style={styles.sectionLabel}>
                      Attendance{" "}
                      <span
                        style={{
                          fontWeight: 400,
                          textTransform: "none",
                          letterSpacing: 0,
                        }}
                      >
                        (please mark from the appropriate below)
                      </span>
                    </p>
                    {errors?.attendance?.length > 0 && (
                      <p className="flex-1 text-danger mt-1 ps-1 fs-12 pb-0 mb-0 ">
                        {errors?.attendance}
                      </p>
                    )}
                    <div style={styles.attendanceGrid}>
                      {attendanceOptions?.map((opt) => (
                        <div
                          key={opt}
                          className="pe-3 py-2 "
                          style={{ borderColor: "rgb(153, 153, 153)" }}
                        >
                          <div className="form-check mb-1">
                            <label
                              className="form-check-label ps-1 pe-2 text-black"
                              htmlFor={`attendance-${opt}`}
                            >
                              {opt}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={opt}
                              id={`attendance-${opt}`}
                              value={opt}
                              checked={formData?.attendance == opt}
                              onChange={() =>
                                handleFieldDataChange("attendance", opt)
                              }
                              disabled={isFieldsNonEditable}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Assessment Table */}
                  <div className="p-3">
                    <p
                      className="assessment-note text-muted small mb-3 "
                      style={{ fontSize: "0.8rem" }}
                    >
                      Please mark a tick (✓) in each group below, against one of
                      the five columns detailed therein so as to describe the
                      employee from your experience and judgement:
                    </p>
                    <div className="table-responsive">
                      <table className="table table-bordered assessment-table w-100">
                        <tbody>
                          {assessmentSections?.map((sec) => (
                            <>
                              <tr
                                key={`${sec.name}-header`}
                                className="section-header"
                              >
                                <td colSpan={6} className="">
                                  <span className="fw-semibold">
                                    {sec.section}
                                  </span>
                                  {errors[sec.name as keyof RatingProps]
                                    ?.length > 0 && (
                                      <p className="flex-1 fw-normal text-danger pb-0 ps-3 mb-0 fs-12 ">
                                        {errors[sec.name]}
                                      </p>
                                    )}
                                </td>
                              </tr>
                              <tr key={sec.name}>
                                <td className="td-description text-start align-top p-2 bg-li">
                                  {sec.description}
                                </td>
                                {sec?.options?.map((opt) => {
                                  const isChecked =
                                    formData?.ratings[
                                    sec.name as keyof RatingProps
                                    ] === opt;
                                  return (
                                    <td
                                      key={opt}
                                      className={`text-center align-middle p-2${isChecked ? " table-warning" : ""}`}
                                    >
                                      <div className="option-cell d-flex flex-column align-items-center justify-content-center gap-2">
                                        <label
                                          htmlFor={`${sec.name}-${opt}`}
                                          className="small text-center user-select-none mb-0"
                                          style={{
                                            cursor: "pointer",
                                            lineHeight: 1.3,
                                          }}
                                        >
                                          {opt}
                                        </label>
                                        <input
                                          type="checkbox"
                                          name={sec.name}
                                          id={`${sec.name}-${opt}`}
                                          value={opt}
                                          checked={isChecked}
                                          onChange={() =>
                                            handleRatingChange(sec.name, opt)
                                          }
                                          disabled={isFieldsNonEditable}
                                        />
                                      </div>
                                    </td>
                                  );
                                })}
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Outcome */}
                  <div style={styles.sectionBorder}>
                    <p style={{ ...styles.sectionLabel }}>
                      Final Decision, Choose One from Below (A/B/C).
                    </p>
                    {errors["finalDecision"]?.length > 0 && (
                      <p className="flex-1 text-danger pb-0 ps-1 mb-0 fs-12 ">
                        {errors["finalDecision"]}
                      </p>
                    )}

                    <div className="checkbox-container mt-3">
                      {probationOutcomeOptions?.map((opt) => {
                        const selected = formData.finalDecision === opt.key;

                        return (
                          <div className="form-check mb-4" key={opt.key}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="finalDecision"
                              id={`finalDecision-${opt.key}`}
                              value={opt.key}
                              checked={selected}
                              onChange={() =>
                                handleFieldDataChange("finalDecision", opt.key)
                              }
                              disabled={isFieldsNonEditable}

                            // onChange={() => set("finalDecision", opt.key)}
                            />

                            <div className="d-flex ">
                              <label
                                className="form-check-label ps-2"
                                htmlFor={`finalDecision-${opt.key}`}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.95rem",
                                  color: "#1a1a1a",
                                  borderColor: "#bfc0c2cb",
                                }}
                              >
                                {opt.key}. {opt.label}
                              </label>

                              {opt?.hasDate && opt.dateName && (
                                <>
                                  <DatePicker
                                    name="terminationDate"
                                    style={{
                                      width: "200px",
                                      marginTop: "-0.5rem",
                                    }}
                                    className="form-control d-inline datetimepicker inline col-4 ms-2"
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    placeholder="DD-MM-YYYY"
                                    value={
                                      formData.terminationDate
                                        ? dayjs(
                                          formData.terminationDate,
                                          "YYYY-MM-DD",
                                        )
                                        : ""
                                    }
                                    disabled={isFieldsNonEditable}
                                    onChange={(
                                      date: any,
                                      dateString: string | string[],
                                    ) => {
                                      if (!date) return;
                                      const formatted =
                                        typeof dateString === "string"
                                          ? dateString
                                          : dateString[0];
                                      handleDateChange(
                                        "terminationDate",
                                        formatted,
                                      );
                                    }}
                                  />
                                  {errors["terminationDate"]?.length > 0 && (
                                    <p className="flex-1 text-danger pt-2 pb-0 ps-2 mb-0 fs-12 ">
                                      {errors["terminationDate"]}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>

                            {selected && (
                              <>
                                <textarea
                                  className="form-control mt-2 ms-2"
                                  rows={opt.rows}
                                  name={opt.name}
                                  value={formData[opt.name] as string}
                                  onChange={(e: any) => handleChange(e)}
                                  // onChange={(e) => set(opt.name, e.target.value)}
                                  readOnly={isFieldsNonEditable}
                                />
                                {errors[opt.name]?.length > 0 && (
                                  <p className="flex-1 text-danger pt-2 pb-0 ps-2 mb-0 fs-12 ">
                                    {errors[opt.name]}
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <hr />
                  {/* Signature */}
                  <div className="mt-3 pb-5">
                    <div className="mt-3 mb-3">
                      <p className="fw-semibold form-dark-text mt-2 mb-3">
                        Signature of (Manager/ HOD)
                      </p>
                      <div>
                        {isAlreadySaved ? <ViewSignature fileSource={formData?.signature_url_manager ?? ""} /> :
                          <ESignaturePad
                            field="managerSignature"
                            onChange={handleSignatureChange}
                            existingSignatureUrl={
                              typeof formData.managerSignature === "string"
                                ? formData.managerSignature // URL string from API (edit mode)
                                : null
                            }
                            error={errors.managerSignature}
                            isDisabled={submitLoading}
                          />
                        }
                        {/* <ESignaturePad
                          field="managerSignature"
                          onChange={handleSignatureChange}
                          existingSignatureUrl={
                            typeof formData.managerSignature === "string"
                              ? formData.managerSignature // URL string from API (edit mode)
                              : null
                          }
                          error={errors.managerSignature}
                        // isDisabled={saveLoading}
                        /> */}
                      </div>
                    </div>
                    <InlineTextInput
                      label="Name:"
                      name="managerName"
                      value={formData?.managerName}
                      onChange={handleChange}
                      errors={errors}
                      isReadOnly={isFieldsNonEditable}

                    // hasBorder={false}
                    />
                    <InlineDateField
                      label="Date:"
                      name="dateManagerSign"
                      value={formData?.dateManagerSign ?? ""}
                      onChange={handleDateChange}
                      disabled={true}
                    />

                    <hr />
                    <div className="mt-4 mb-2">
                      <ViewSignature
                        fileSource={"/assets/img/harneet_seth_signature.png"}
                      />
                      <p className="fw-semibold form-dark-text mt-3 mb-0">
                        Designation: Human Resources
                      </p>
                    </div>
                    <InlineTextInput
                      label="Name:"
                      name="hrName"
                      // value={"Harneet Seth"}
                      value={formData?.hrName}
                      onChange={handleChange}
                      errors={errors}
                      isReadOnly={true}
                    // isReadOnly={isFieldsNonEditable}

                    // hasBorder={false}
                    />
                    <InlineDateField
                      label="Date:"
                      name="dateHrSign"
                      value={formData?.dateHrSign ?? ""}
                      onChange={handleDateChange}
                      disabled={true}
                    />
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      disabled={
                        submitLoading || fetchLoading || isFieldsNonEditable
                      }
                      // disabled={Object.keys(errors)?.length > 0 || submitLoading}
                      className="btn btn-primary"
                    >
                      {submitLoading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
          {/* /Form Content */}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default ProbationAssessmentForm;
